import {createSelector} from "reselect";
import {IStore} from "modules/types/store";

export const getModalState = (store: IStore) => store.modals;
export const getErrorModalMessage = createSelector(getModalState, ({error}) => error);
export const getSuccessModalMessage = createSelector(getModalState, ({message}) => message);

export const getIsOpenModals = createSelector(getModalState, ({isOpenModals}) => isOpenModals);

export const getIsOpenSavedAnswersModal = createSelector(
	getIsOpenModals,
	({savedAnswersModal}) => savedAnswersModal
);

export const getIsOpenSSOAdditionalFieldsModal = createSelector(
	getIsOpenModals,
	({SSOAdditionalFieldsModal}) => SSOAdditionalFieldsModal
);

export const getIsOpenDontLosePicksModal = createSelector(
	getIsOpenModals,
	({dontLosePicksModal}) => dontLosePicksModal
);
